import { Action } from '@ngrx/store'
import { SKU } from '../models/sku'

export const GET = '[SKUs] Get'
export const GET_SUCCESS = '[SKUs] Get Success'
export const GET_FAILED = '[SKUs] Get Failed'

export class Get implements Action {
    readonly type = GET
    constructor(public payload: string) {}
}
export class GetSuccess implements Action {
    readonly type = GET_SUCCESS
    constructor(public payload: SKU[]) {}
}
export class GetFailed implements Action {
    readonly type = GET_FAILED
    constructor(public payload: any) {}
}

export type Actions = 
    Get
    | GetSuccess
    | GetFailed